// extracted by mini-css-extract-plugin
export default {"section":"home_section__FYLQA","card":"home_card__YrX75","cardTitle":"home_cardTitle__GQEyn","cardContent":"home_cardContent__YMp+W"};